<template>
  <b-card-group>
    <b-card no-body>
      <div class="card-body">
        <div>
          <b-form class="filter-form">
            <b-row>
              <b-col cols="1">
                <b-button v-on:click="reset" size="sm" variant="secondary" class="ml-2">
                  <font-awesome-icon icon="times" />
                  {{ $t('Сброс') }}
                </b-button>
              </b-col>
              <filter-select
                :label="$t('Тип аллели')"
                :cols="2"
                v-model="form.hlaType"
                :options="hlaTypes"
                v-on:onChange="search"
              ></filter-select>
              <filter-input
                :label="$t('Значение в группе G')"
                :cols="2"
                v-model="form.sourceG"
                v-on:onBlur="search"
              ></filter-input>
              <filter-input
                :label="$t('Аллели в группе')"
                :cols="2"
                v-model="form.dest"
                v-on:onBlur="search"
              ></filter-input>
            </b-row>
          </b-form>
        </div>
      </div>
    </b-card>
  </b-card-group>
</template>

<script>
import axios from 'axios';
import BaseFilter from '@/models/base.filter';

export default {
  name: 'filter-form',
  extends: BaseFilter,
  props: {
    hlaType: Number,
    sourceG: String,
    dest: String,
  },
  data() {
    return {
      form: {
        hlaType: this.hlaType,
        sourceG: this.sourceG || '',
        dest: this.dest || '',
      },
      hlaTypes: [],
    };
  },
  methods: {
    getDictionaries() {
      axios
        .get('/Dictionary/GetHlaTypes')
        .then((response) => {
          this.hlaTypes = response.data;
        });
    },
  },
};
</script>
